import { MEMBERS_SERVICE } from "@/services/members.service.js";

const state = {getMembersOutput: {}, postMemberOutput: false, putMemberOutput: false, deleteMemberByIdOutput: false, getMemberDetailsOutput: {}};

const actions = {
    //Service to get members
    getMembers({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getMembersRequest');

        MEMBERS_SERVICE.getMembers(queryParams)
            .then(
                output => {
                    commit('getMembersSuccess', output);
                },
                error => {
                    commit('getMembersFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create members
    postMember({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postMemberRequest');

        MEMBERS_SERVICE.postMember(input)
            .then(
                output => {
                    commit('postMemberSuccess', output);
                },
                error => {
                    commit('postMemberFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update member
    putMember({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putMemberRequest');

        MEMBERS_SERVICE.putMember(input)
            .then(
                output => {
                    commit('putMemberSuccess', output);
                },
                error => {
                    commit('putMemberFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove member
    deleteMemberById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteMemberByIdRequest');

        MEMBERS_SERVICE.deleteMemberById(id)
            .then(
                output => {
                    commit('deleteMemberByIdSuccess', output);
                },
                error => {
                    commit('deleteMemberByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get products details
    getMemberDetails({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getMemberDetailsRequest');

        MEMBERS_SERVICE.getMemberDetails(queryParams)
            .then(
                output => {
                    commit('getMemberDetailsSuccess', output);
                },
                error => {
                    commit('getMemberDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getMembers
    getMembersRequest(state) {
    },
    getMembersSuccess(state, output) {
        state.getMembersOutput = output;
    },
    getMembersFailure(state) {
        state.getMembersOutput = false;
    },

    //postMember
    postMemberRequest(state) {
        state.postMemberOutput = null;
    },
    postMemberSuccess(state, output) {
        state.postMemberOutput = true;
    },
    postMemberFailure(state) {
        state.postMemberOutput = false;
    },

    //putMember
    putMemberRequest(state) {
        state.putMemberOutput = null;
    },
    putMemberSuccess(state, output) {
        state.putMemberOutput = true;
    },
    putMemberFailure(state) {
        state.putMemberOutput = false;
    },

    //deleteMemberById
    deleteMemberByIdRequest(state) {
        state.deleteMemberByIdOutput = null;
    },
    deleteMemberByIdSuccess(state, output) {
        state.deleteMemberByIdOutput = true;
    },
    deleteMemberByIdFailure(state) {
        state.deleteMemberByIdOutput = false;
    },

    //getMemberDetails
    getMemberDetailsRequest(state) {
    },
    getMemberDetailsSuccess(state, output) {
        state.getMemberDetailsOutput = output;
    },
    getMemberDetailsFailure(state) {
        state.getMemberDetailsOutput = false;
    },
};

export const members = {
    namespaced: true,
    state,
    actions,
    mutations
};